import { apiSlice } from './api';
import { DecreaseBalanceRequest, UserInfo, UserBalanceResponse, EditProfileRequest } from '@/types/users';

export const usersSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getUser: builder.query<UserInfo, string>({
      query: id => `/api/users/${id}`
    }),

    getUserBalance: builder.query<UserBalanceResponse, string>({
      query: id => `/api/balance/user/${id}`,
      providesTags: (result, error, id) => [{ type: 'UserBalance', id }]
    }),

    decreaseMinute: builder.mutation<void, { body: DecreaseBalanceRequest; id: string }>({
      query: ({ body, id }) => ({
        url: `/api/balance/user/${id}/decrease`,
        method: 'POST',
        body
      })
    }),

    editProfile: builder.mutation<UserInfo, { body: EditProfileRequest; id: string }>({
      query: ({ body, id }) => ({
        url: `/api/users/${id}`,
        method: 'PUT',
        body
      })
    })
  })
});

export const {
  useLazyGetUserQuery,
  useGetUserBalanceQuery,
  useLazyGetUserBalanceQuery,
  useDecreaseMinuteMutation,
  useEditProfileMutation
} = usersSlice;
